import React from "react";
import { PageNewPymesPrice } from "../Components/Page_New_pymes/PageNewPymesPrice";


export const NewPagePymesPrice = () => {

    return (
        <>
           <PageNewPymesPrice></PageNewPymesPrice>
        </>
    )
}
